import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import { Breadcrumb, BreadcrumbItem, Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

class TimelineHeader extends React.Component {
  render() {
    return (
      <>
        <div className='header header-dark bg-info pb-6 content__title content__title--calendar'>
          <Container fluid>
            <div className='header-body py-4'>
              <h6 className='fullcalendar-title h2 text-white d-inline-block mb-0 mr-20'>{this.props.name}</h6>{' '}
              <Breadcrumb className='d-none d-md-inline-block ml-lg-4 text-white' listClassName='breadcrumb-links breadcrumb-dark'>
                <BreadcrumbItem>
                  <Link to={'/lms/home'}>
                    <i className='fas fa-home' />
                  </Link>
                </BreadcrumbItem>
                {this.props.parentName ? <BreadcrumbItem>{this.props.parentName}</BreadcrumbItem> : null}
                {this.props.name ? <BreadcrumbItem>{this.props.name}</BreadcrumbItem> : null}
              </Breadcrumb>
              {/* <Col className='mt-3 mt-md-0 text-md-right' lg='6' xs='5'>
                  <Button className='btn-neutral' color='default' size='sm'>
                    New
                  </Button>
                  <Button className='btn-neutral' color='default' size='sm'>
                    Filters
                  </Button>
                </Col> */}
            </div>
          </Container>
        </div>
      </>
    );
  }
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default TimelineHeader;
